// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/mobileDashboard.css
// module id = 1331
// module chunks = 37